// extracted by mini-css-extract-plugin
module.exports = {"numberInput":"number-input-bb8","numberInputButtons":"number-input__buttons-525"};